import { gql, useMutation } from "@apollo/client";

const UPDATE_MERCHANT = gql`
  mutation (
    $id: UUID!
    $type: MerchantType!
    $name: String!
    $biography: String
    $phone: String
    $business_name: String
    $url: String
    $tax_id: String
    $vat_id: String
  ) {
    updateMerchant(
      id: $id
      input: {
        type: $type
        name: $name
        biography: $biography
        phone: $phone
        business_name: $business_name
        url: $url
        tax_id: $tax_id
        vat_id: $vat_id
      }
    ) {
      id
      type
      name
      biography
      phone
      business_name
      url
      tax_id
      vat_id
    }
  }
`;

const useUpdateMerchant = () => {
  return useMutation(UPDATE_MERCHANT);
};

export default useUpdateMerchant;
